import dayjs from "@lib/dayjs";
import React, { useEffect, useRef, useState } from "react";
import LoadingAnimation from "../../../../../assets/svg/LoadingAnimation";
import { isNullOrEmpty } from "../../../../../utils/helperFunction";
import { JobType } from "../../../../../utils/constants";
import { getReferralTrackers } from "../../../../../endpoints/referral.service";
import { enqueueSnackbar } from "notistack";
import { useLocation } from "react-router-dom";

const ApplicationTrackerTab = ({ applicationTracker }) => {
  const [loading, setLoading] = useState(false);
  const [trackerList, setTrackerList] = useState();
  const hasFetched = useRef(false);
  useEffect(() => {
    if (!hasFetched.current && applicationTracker?.jobData?.applicationId) {
      hasFetched.current = true;
      fetchTracker();
    }
  }, []);

  useEffect(() => {
    if (applicationTracker?.jobData?.applicationId) {
      fetchTracker();
    }
  }, []);

  const fetchTracker = async () => {
    try {
      setLoading(true);
      const { data, success } = await getReferralTrackers(
        applicationTracker.jobData.applicationId
      );
      if (success && data) {
        const sortedData = data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTrackerList(sortedData);
      }
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex gap-6 h-screen overflow-hidden">
      <div className="w-3/5 overflow-y-auto h-full no-scrollbar">
        {loading ? (
          <div className="flex justify-center mt-40 h-full">
            <LoadingAnimation color="black" />
          </div>
        ) : isNullOrEmpty(trackerList) ? (
          <div className="flex justify-center mt-40 h-full font-medium">
            No data tracked!
          </div>
        ) : (
          <>
            {trackerList?.map((list, index) => (
              <div
                key={index}
                className="bg-[#FAFAFA] rounded-lg p-4 mb-3 border border-[#DDDDDD] flex gap-12 cursor-pointer hover:bg-gray-100"
              >
                <div className="flex flex-col gap-3.5 w-1/2">
                  <div className="flex flex-shrink-0 font-medium text-xs text-light-black gap-4">
                    {dayjs(list?.createdAt).format("h:mm a DD MMMM YYYY")}
                  </div>
                  <div
                    className={`py-1.5 rounded text-center text-xs font-medium ${
                      list.title === "Offer Accepted"
                        ? "bg-light-black text-white"
                        : "bg-[#F1F5F9] border border-[#DDDDDD] text-primary"
                    }`}
                  >
                    {list.status === "Submit Offer"
                      ? "Offer received"
                      : list.status === "Decline"
                      ? "Application declined"
                      : list.status === "Shortlist"
                      ? "Shortlisted"
                      : list.status}
                  </div>
                </div>
                <p className="bg-white text-light-black font-medium text-xs py-1.5 px-8 self-end rounded w-1/2 text-center h-7">
                  {dayjs(list?.createdAt).format("DD/MM/YY")}
                </p>
              </div>
            ))}
          </>
        )}
      </div>

      <div className="bg-[#F1F5F9] p-4 space-y-3 rounded-lg w-2/5 h-3/5 overflow-y-hidden">
        <div className="flex justify-between">
          {applicationTracker?.jobData?.candidateDetails?.profilePic ? (
            <img
              src={applicationTracker?.jobData?.candidateDetails?.profilePic}
              className="rounded-full w-14 h-14 object-fill z-10 max-md:h-36 max-md:w-36"
            />
          ) : (
            <div className="font-montserrat text-white font-semibold uppercase w-14 h-14 rounded-full bg-gray-400 flex items-center justify-center text-xl">
              {applicationTracker.jobData?.candidateDetails?.firstName.charAt(
                0
              )}
              {applicationTracker.jobData?.candidateDetails?.lastName.charAt(0)}
            </div>
          )}
          <span className="bg-white text-primary font-medium text-xs py-1.5 px-8 rounded h-max">
            {applicationTracker?.jobData.candidateDetails?.refNo ?? "-"}
          </span>
        </div>
        <div className="text-primary space-y-2 text-xs">
          <p className="font-bold">
            {applicationTracker?.jobData?.candidateDetails?.firstName &&
            applicationTracker?.jobData?.candidateDetails?.lastName
              ? `${applicationTracker.jobData?.candidateDetails?.firstName} ${applicationTracker?.jobData?.candidateDetails?.lastName}`
              : "-"}
          </p>
        </div>
        <div className="flex flex-col gap-3.5">
          <span className="font-medium text-primary text-xs flex-1">
            {applicationTracker?.jobData?.jobTitle ?? "-"}
          </span>
          <div className="flex flex-col gap-3.5 mb-6">
            <div className="flex gap-5">
              <span className="text-xs text-light-black w-28">Location:</span>
              <span className="font-medium text-primary text-xs flex-1">
                {applicationTracker?.jobData?.candidateDetails?.address ?? "-"}
              </span>
            </div>
            <div className="flex gap-5">
              <span className="text-xs text-light-black w-28">
                Industry Type:
              </span>
              <span className="font-medium text-primary text-xs flex-1">
                {applicationTracker?.jobData?.candidateDetails?.industryType ??
                  "-"}
              </span>
            </div>
            <div className="flex gap-5">
              <span className="text-xs text-light-black w-28">Job Type:</span>
              <span className="font-medium text-primary text-xs flex-1">
                {JobType.find(
                  (x) =>
                    x.value ===
                    applicationTracker?.jobData?.candidateDetails?.jobType
                )?.label ?? "-"}
              </span>
            </div>
            <div className="flex gap-5">
              <span className="text-xs text-light-black w-28">
                Salary Range:
              </span>
              <span className="font-medium text-primary text-xs flex-1">
                {applicationTracker?.jobData?.candidateDetails?.salary?.min &&
                applicationTracker?.jobData?.candidateDetails?.salary?.max ? (
                  <>
                    £
                    {applicationTracker?.jobData?.candidateDetails?.salary?.min}{" "}
                    - £
                    {applicationTracker?.jobData?.candidateDetails?.salary?.max}
                  </>
                ) : (
                  <>-</>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationTrackerTab;
